export default "__VITE_ASSET__eaLm37IC__"